import React from 'react';
import throttle from 'lodash/throttle';

/* eslint-disable react/sort-comp */
function createPosiotionInfo(oldMouse, newX, newY) {
  if (!oldMouse) {
    return {
      shiftX: 0,
      shiftY: 0,
      firstX: newX,
      firstY: newY,
      x: newX,
      y: newY,
    };
  }

  const { firstX, firstY } = oldMouse;

  return {
    x: newX,
    y: newY,
    shiftX: firstX - newX,
    shiftY: firstY - newY,
    firstY,
    firstX,
  };
}

export default class MovableByMouse extends React.PureComponent {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
    this.wrapperRef = React.createRef();

    this.state = {
      mouse: null,
    };
  }

  render() {
    const { children } = this.props;
    const { mouse, newRefCoordinates } = this.state;
    const renderedChildren = children(this.ref, mouse, newRefCoordinates, this.createMouseSubscriptions);

    return <div ref={this.wrapperRef}>{renderedChildren}</div>;
  }

  // eslint-disable-next-line class-methods-use-this
  elementSelector = (wrapperElement) => wrapperElement && wrapperElement.firstChild;

  mousedown = (e) => {
    // eslint-disable-next-line react/destructuring-assignment
    if (!this.props.validateMousedownEvent(e)) {
      return;
    }

    const current = this.elementSelector(this.wrapperRef.current);

    const rec = current.getBoundingClientRect();
    const { clientX, clientY } = e;

    this.setState({
      mouse: createPosiotionInfo(null, clientX, clientY),
      refMousedownPosition: rec,
      newRefCoordinates: {
        x: rec.left,
        y: rec.top,
      },
    });

    document.addEventListener('mousemove', this.mousemove);
  };

  mouseup = () => {
    document.removeEventListener('mousemove', this.mousemove);
  };

  mousemove = throttle((e) => {
    const { clientX, clientY } = e;
    const { mouse, refMousedownPosition } = this.state;
    const newMouse = createPosiotionInfo(mouse, clientX, clientY);

    this.setState({
      mouse: newMouse,
      newRefCoordinates: {
        x: refMousedownPosition.x - newMouse.shiftX,
        y: refMousedownPosition.y - newMouse.shiftY,
      },
    });
  }, 30);

  createMouseSubscriptions = () => {
    const current = this.elementSelector(this.wrapperRef.current);

    if (!current) {
      return;
    }

    current.addEventListener('mousedown', this.mousedown);
    document.addEventListener('mouseup', this.mouseup);
  };

  componentDidMount() {
    this.createMouseSubscriptions();
  }

  componentWillUnmount() {
    const current = this.elementSelector(this.wrapperRef.current);

    document.removeEventListener('mousemove', this.mousemove);

    if (!current) {
      return;
    }

    current.removeEventListener('mousedown', this.mousedown);
    document.removeEventListener('mouseup', this.mouseup);
  }
}

MovableByMouse.defaultProps = {
  validateMousedownEvent: () => true,
};
